import filterTypes from 'components/list/Filters/filterMatchTypes';

/**
 * Converts the value to the expected filter value based on the match type.
 *
 * @param {string} type
 * @param {string|number} value
 *
 * @returns {string}
 */
const doMatchType = (type, value) => {
    switch (type) {
        case filterTypes.contains:
            value = `*${ value }*`.replace(' ', '*');
            break;
        case filterTypes.endsWith:
            value = `*${ value }`;
            break;
        case filterTypes.startsWith:
            value = `${ value }*`;
            break;
        case filterTypes.between:
        case filterTypes.equals:
        case filterTypes.matchAllOf:
        case filterTypes.matchOneOf:
        case filterTypes.near:
        case filterTypes.range:
        default:
            value = `${ value }`;
            break;
    }

    return value.trim();
};

export default doMatchType;



// WEBPACK FOOTER //
// ./src/clients/doMatchType.js